import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {Table} from 'reactstrap';
import {toast} from 'react-toastify';
import {isEmpty} from 'lodash';

import ErrorMsg from "../common/ErrorMsg";
import LoadingModal from "../common/LoadingModal";


export default class UserActivityModal extends Component {
    state = {
        userActivityLogList: []
    }

    componentDidMount = () => {
        if (!isEmpty(this.props.selectedLog)) {
            this.getInitialState();
        }
    };

    getInitialState = async () => {
        try {
            let result = await this.props.getUserActivityLogList(this.props.selectedLog.id);

            if(result) {
                let userActivityLogList = result.map(log => ({...log}));
                this.setState({userActivityLogList});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
        }
    };

    toggleModal = () => {
        this.setState({userActivityLogList: []});
        this.props.toggleModal();
    }

    render() {
        const {userActivityLogList} = this.state;

        let tableRows = userActivityLogList.map((log, index) => {
            return (
                <tr key={index}>
                    <td>{log.user_name}</td>
                    <td className="text-center">{log.no_of_records}</td>
                    <td className="text-center">{log.description}</td>
                </tr>
            );
        });
        return (
            <Modal isOpen={this.props.modal} toggle={this.toggleModal}>
                <ModalHeader toggle={this.toggleModal}>
                    Activity Log - {this.props.selectedLog.created_at}
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <Table responsive striped bordered hover={0} size="sm" className="mb-0 bg-white">
                                <thead>
                                    <tr>
                                        <th className="font-weight-bold">User Name</th>
                                        <th className="font-weight-bold text-center">No of Records<br/> Imported</th>
                                        <th className="font-weight-bold text-center">Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableRows}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button className='btn btn-secondary' onClick={this.toggleModal}>Close</Button>
                </ModalFooter>
                {this.state.isLoading ? <LoadingModal modal={this.state.isLoading} /> : null}
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/adminHome/UserActivityModal.js